import api from "./httpService";

export type PermissionKey = string;

export type RolePayload = {
    name: string;
    description?: string;
    isActive?: boolean;
    permissions: PermissionKey[];
};

const readArray = (value: unknown): unknown[] => {
    if (Array.isArray(value)) return value;
    if (value && typeof value === "object") {
        const data = value as { data?: unknown; roles?: unknown; permissions?: unknown; items?: unknown };
        if (Array.isArray(data.data)) return data.data;
        if (Array.isArray(data.roles)) return data.roles;
        if (Array.isArray(data.permissions)) return data.permissions;
        if (Array.isArray(data.items)) return data.items;
    }
    return [];
};

export const getRoles = async () => {
    const response = await api.get("/roles");
    return readArray(response.data);
};

export const getRoleById = async (id: string) => {
    const response = await api.get(`/roles/${id}`);
    return response.data;
};

export const createRole = async (payload: RolePayload) => {
    const response = await api.post("/roles", payload);
    return response.data;
};

export const updateRole = async (id: string, payload: RolePayload) => {
    const response = await api.put(`/roles/${id}`, payload);
    return response.data;
};

export const deleteRole = async (id: string) => {
    const response = await api.delete(`/roles/${id}`);
    return response.data;
};

export const getPermissions = async () => {
    const response = await api.get("/permissions");
    return readArray(response.data);
};
